import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n/I18nContext";
import SectionHead from "../components/SectionHead";

const ease = [0.16, 1, 0.3, 1];

export default function LongView() {
  const { t } = useI18n();
  return (
    <section
      id="longview"
      className="section border-t hair"
      data-testid="longview-section"
    >
      <div className="container-edge">
        <SectionHead
          roman={t.sections.longview.roman}
          right={<span className="mono" style={{ color: "var(--faded)" }}>fig. 03</span>}
        />

        <div className="grid grid-cols-12 gap-y-12 md:gap-x-10 mb-24 md:mb-36">
          <motion.h2
            className="col-span-12 md:col-span-7 display text-[48px] sm:text-[64px] md:text-[96px] lg:text-[128px]"
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease }}
            data-testid="longview-heading"
          >
            {t.longview.heading}
          </motion.h2>
          <motion.p
            className="col-span-12 md:col-span-4 md:col-start-9 body-text self-end"
            style={{ maxWidth: "34ch" }}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease, delay: 0.1 }}
          >
            {t.longview.sub}
          </motion.p>
        </div>

        {/* big tabular stats */}
        <div
          className="grid grid-cols-12 gap-y-14 md:gap-x-10 border-t hair pt-16 md:pt-20"
          data-testid="longview-stats"
        >
          {t.longview.stats.map((s, i) => (
            <motion.div
              key={i}
              className="col-span-12 md:col-span-4 flex flex-col"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease, delay: i * 0.1 }}
              data-testid={`stat-${i + 1}`}
            >
              <p className="mono mb-6" style={{ color: "var(--faded)" }}>
                — {s.k}
              </p>
              <p
                className="display text-[44px] sm:text-[56px] md:text-[68px] lg:text-[80px] leading-[0.95] mb-4"
                style={{ fontWeight: 500, fontVariantNumeric: "tabular-nums", overflowWrap: "break-word", hyphens: "auto" }}
              >
                {s.v}
              </p>
              <p className="text-[15px] md:text-[16px]" style={{ color: "var(--ink)", fontWeight: 300, maxWidth: "30ch" }}>
                {s.unit}
              </p>
              <p className="mono mt-4" style={{ color: "var(--faded)" }}>
                {s.cite}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
